import Vue from 'vue'
import { Toast, Overlay, Loading, Popup, Button, Dialog } from 'vant'

Vue.use(Toast)
Vue.use(Overlay)
Vue.use(Loading)
Vue.use(Popup)
Vue.use(Button)
Vue.use(Dialog)